export default __webpack_public_path__ + "static/media/ic_emoji.a9a00a42.svg";